<template>
	<div>
		<div class="row">
                <div class="col-sm-12">
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.super_admin.billings.items.name') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="text" maxlength="50" class="form-control" v-model="item.name">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.super_admin.billings.items.cost') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="item.cost">
                        </div>
                    </div>
                    <div class="row mb-3" v-if="item.haveVat">
                        <div class="col-lg-4">
                            <label>{{ $t('general.super_admin.billings.items.vat') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="item.vat" min="0" max="100">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.super_admin.billings.items.quantity') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <input type="number" onKeyPress="if(this.value.length==8) return false;" step=".01" class="form-control" v-model="item.quantity">
                        </div>
                    </div>
                    <div class="row mb-3">
                        <div class="col-lg-4">
                            <label>{{ $t('general.super_admin.billings.items.description') }}</label>
                        </div>
                        <div class="col-lg-8">
                            <textarea rows="6" maxlength="5000" class="form-control" v-model="item.description"></textarea>
                        </div>
                    </div>
                </div>
            </div>
	</div>
</template>

<script>
	import Vue from 'vue';
	import flatPickr from 'vue-flatpickr-component';
	import 'flatpickr/dist/flatpickr.css';

	export default {
		name: 'BillingItemModal',
		props: {
			item: {
				default: ''
			}
		},
		components: {
			flatPickr,
		},
		data() {
			return {
			}
		},
		created() {
		},
		mounted() {
		},
		computed: {
		},
		methods: {
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/global/modals/BillingItemModal.vue